import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import { signOut } from "firebase/auth";
import auth from "../../firebase.init";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuthState } from "react-firebase-hooks/auth";
const pages = [
  {
    _id: 1,
    name: "About",
    route: "/about",
    href: "#about",
  },
  {
    _id: 2,
    name: "Services",
    route: "/services",
    href: "#services",
  },
  {
    _id: 3,
    name: "FAQ",
    route: "/faq",
    href: "#faq",
  },
  {
    _id: 4,
    name: "Contact",
    route: "/contact",
    href: "#contact",
  },
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const ResponsiveAppBar = () => {
  const [user, loading, error] = useAuthState(auth);

  const logout = () => {
    signOut(auth);
  };
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  console.log(user);
  return (
    <AppBar position="static" color="inherit">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Link to="/">
            {" "}
            <img className="hidden lg:block lg:h-10 mx-2 " src={logo} alt="" />
          </Link>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="secondary"
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page._id} onClick={handleCloseNavMenu}>
                  {/* <Link to={page.route}> */}
                  <a href={page.href}>{page.name}</a>
                  {/* </Link> */}
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <AppDrawer /> */}
          {/* <Link to="/">
            {" "}
            <img className=" lg:hidden  h-6 mx-2" src={logo} alt="" />
          </Link> */}

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              // <Link
              //   className="px-4"
              //   key={page._id}
              //   to={page.route}
              //   onClick={handleCloseNavMenu}
              //   sx={{ my: 2, color: "white", display: "block" }}
              // >
              <a className="px-4" href={page.href}>
                {page.name}
              </a>
              // </Link>
            ))}
          </Box>
          {/* <SearchBar /> */}
          <Box sx={{ flexGrow: 0 }}>
            {user ? (
              <Box>
                <Tooltip title="User">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 1 }}>
                    <Avatar
                      alt={user?.displayName?.toLocaleUpperCase()}
                      src={user?.photoURL}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Logout">
                  <IconButton onClick={logout} sx={{ p: 1 }}>
                    <LogoutIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              <Link to="/login">Login</Link>
            )}

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
